import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=520856bc&scoped=true"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=520856bc&prod&scoped=true&lang=css"
import style1 from "~/assets/style/toolbar-panels.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520856bc",
  null
  
)

export default component.exports